module.exports = "<example-shell\n  exampleId=\"dark\" [title]=\"title\" [summary]=\"summary\" [dataSnippet]=\"dataSnippet\" [events]=\"events\" (clear)=\"clearEvents()\">\n  <stackline-data-table\n    title=\"Dark theme\"\n    theme=\"dark\"\n    [columns]=\"revenueColumns\"\n    [data]=\"revenue\"\n    [pagination]=\"true\"\n    [paginationPerPage]=\"5\"\n    [fixedHeader]=\"true\"\n    fixedHeaderScrollHeight=\"320px\"\n    [striped]=\"true\"\n    [highlightOnHover]=\"true\">\n  </stackline-data-table>\n</example-shell>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/dark/dark.component.html
// module id = ./src/app/examples/dark/dark.component.html
// module chunks = main